import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MaterialModule } from '@app/material.module'
import { NgxMaskModule } from 'ngx-mask'
import { FormComponent, InputFieldComponent, PasswordFieldComponent, SelectFieldComponent } from '.'
import { AlertComponent } from './alert/alert.component'
import { AutocompleteFieldComponent } from './autocomplete-field/autocomplete-field.component'
import { ButtonComponent } from './button/button.component'
import { CheckboxFieldComponent } from './checkbox-field/checkbox-field.component'
import { DateFieldMonthComponent } from './date-field-month/date-field-month.component'
import { DateFieldYearComponent } from './date-field-year/date-field-year.component'
import { DateFieldComponent } from './date-field/date-field.component'
import { DateRangeFieldComponent } from './date-range-field/date-range-field.component'
import { ErrorFieldComponent } from './error-field/error-field/error-field.component'
import { ExpansionPanelComponent } from './expansion-panel/expansion-panel.component'
import { FormHelperService } from './form/services/form-helper.service'
import { IconButtonComponent } from './icon-button/icon-button.component'
import { InfoAreaComponent } from './info-area/info-area.component'
import { InfoLabelComponent } from './info-label/info-label.component'
import { InputFieldCurrencyComponent } from './input-field-currency/input-field-currency.component'
import { InputFieldNumberComponent } from './input-field-number/input-field-number.component'
import { LabelComponent } from './label/label.component'
import { MenuItemComponent } from './menu-item/menu-item.component'
import { MenuComponent } from './menu/menu.component'
import { MultiSelectFieldComponent } from './multi-select-field/multi-select-field.component'
import { PageHeaderComponent } from './page-header/page-header.component'
import { PipesModule } from './pipes/pipes.module'
import { RadioFieldComponent } from './radio-field/radio-field.component'
import { TagComponent } from './tag/tag.component'
import { TextAreaFieldComponent } from './text-area-field/text-area-field.component'
import { TextAvatarComponent } from './text-avatar/text-avatar.component'

@NgModule({
  declarations: [
    InputFieldComponent,
    InputFieldNumberComponent,
    InputFieldCurrencyComponent,
    SelectFieldComponent,
    FormComponent,
    PasswordFieldComponent,
    AutocompleteFieldComponent,
    ButtonComponent,
    AutocompleteFieldComponent,
    RadioFieldComponent,
    AlertComponent,
    CheckboxFieldComponent,
    LabelComponent,
    TagComponent,
    TextAreaFieldComponent,
    MenuComponent,
    MenuItemComponent,
    DateFieldComponent,
    InfoLabelComponent,
    PageHeaderComponent,
    MultiSelectFieldComponent,
    ExpansionPanelComponent,
    TextAvatarComponent,
    InfoAreaComponent,
    DateFieldMonthComponent,
    DateRangeFieldComponent,
    DateFieldYearComponent,
    ErrorFieldComponent,
    IconButtonComponent,
  ],
  imports: [
    PipesModule,
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule.forRoot({
      validation: false,
    }),
  ],
  providers: [FormHelperService],
  exports: [
    PipesModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    InputFieldComponent,
    InputFieldNumberComponent,
    InputFieldCurrencyComponent,
    SelectFieldComponent,
    RadioFieldComponent,
    PasswordFieldComponent,
    AutocompleteFieldComponent,
    ButtonComponent,
    FormComponent,
    FormsModule,
    AlertComponent,
    CheckboxFieldComponent,
    LabelComponent,
    TagComponent,
    TextAreaFieldComponent,
    MenuComponent,
    MenuItemComponent,
    DateFieldComponent,
    InfoLabelComponent,
    PageHeaderComponent,
    MultiSelectFieldComponent,
    ExpansionPanelComponent,
    TextAvatarComponent,
    InfoAreaComponent,
    DateFieldMonthComponent,
    DateRangeFieldComponent,
    DateFieldYearComponent,
    ErrorFieldComponent,
    IconButtonComponent,
  ],
})
export class WidgetsModule {}
